(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function parsePx(value) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function mountHeroScroll(root) {
    if (!root || root.dataset.heroScrollMounted === 'true') return;

    var hero = root.querySelector('[data-hero-banner]');
    var copy = root.querySelector('[data-hero-copy]');
    if (!hero || !copy) return;

    root.dataset.heroScrollMounted = 'true';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktop = window.matchMedia('(min-width: 960px)');
    var ticking = false;
    var maxScrollOffset = 280;

    function resetTransform() {
      copy.style.transform = '';
    }

    function applyOffset() {
      ticking = false;

      if (!desktop.matches || reduceMotion.matches) {
        resetTransform();
        return;
      }

      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var rect = hero.getBoundingClientRect();
      var heroTop = scrollY + rect.top;
      var heroHeight = Math.max(hero.offsetHeight, 1);
      var heroBottom = heroTop + heroHeight;

      if (scrollY <= heroTop) {
        copy.style.transform = 'translate3d(0, ' + parsePx(getComputedStyle(copy).getPropertyValue('--hero-copy-base-offset')) + 'px, 0)';
        return;
      }

      if (scrollY >= heroBottom) {
        var endBase = parsePx(getComputedStyle(copy).getPropertyValue('--hero-copy-base-offset'));
        copy.style.transform = 'translate3d(0, ' + (endBase + maxScrollOffset) + 'px, 0)';
        return;
      }

      var baseOffset = parsePx(getComputedStyle(copy).getPropertyValue('--hero-copy-base-offset'));
      var progress = clamp((scrollY - heroTop) / heroHeight, 0, 1);
      var offset = baseOffset + progress * maxScrollOffset;
      copy.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0)';
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(applyOffset);
    }

    applyOffset();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', requestUpdate);
      reduceMotion.addEventListener('change', requestUpdate);
    }
  }

  function init() {
    document.querySelectorAll('.facilitadores-landing-html').forEach(mountHeroScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
})();
